import { RfqStock } from '@app/core/locations/store/locations.model';
import { SalesOrder } from '@app/core/sales/store/sales-order.model';

export const InventoryTransactionConstant :any = {
  ADD_ACTION: 'ADD',
  UPDATE_ACTION: 'UPDATE',
  DEDUCT_ACTION: 'SUBTRACT',
  REPLACE_ACTION: 'REPLACE',
};

export interface RfqStockLocation {
  id :number;
  rfq_stock ?:RfqStock;
  location_id :number;
}

export interface IRfqQtyLogs {
  id :number;
  remarks :string;
  channelLabel :string;
  isClickableRemarks :boolean;
  isformattableDetails :boolean;
  order ?:SalesOrder;
  details :string;
  linkTransactionNumber :number;
  locationId :number;
  transferId :number;
  transferLog ?:ITransferLog;
  action :string;
  baseUomId :number;
  lotId :number;
  locationRunningBalance :number;
  orderedQty :number;
  orderedUomId :number;
  qtyType :string;
  quantity :number;
  runningQuantityBalance :number;
  shipstationOrderId :number;
  transaction :string;
  transactionId :number;
  remarkLink :string;
}

export interface ITransferLog {
  id :number;
  source_location_id :number;
  destination_location_id :number;
}

export interface IRfq {
  id :number;
  addedBy :number;
  businessAccountId :number;
  productName :string;
  productDescription :string;
  unitsQtyAnnual :number;
  unitsQtyFirst :number;
  targetPrice :number;
  productCategoryId :number;
  productCategory ?:string;
  willPurchaseSample :number;
  isProductInMarket :number;
  productLink :any;
  destinationAddress :string;
  destinationCity :string;
  destinationState :string;
  destinationZip :string;
  hasPrototype :number;
  hasPackingReq :number;
  otherDetails :string;
  quotationsCount :number;
  photo :string;
  status :number;
  purchaseOrderDt :string;
  sampleOrderDt :string;

  unitsQtyAnnualType :number;
  addressNotKnown :number;
  changesToMake :string;
  developmentStatus :string;
  unitsQtyMoq :number;
  brandProduct :number;
  artworkAvailable :number;
  productHasVariants :number;
  productVariants :any;

  prLabelingStickers :number;
  prCustomPrinting :number;
  prBundling :number;
  prVariousPrep :number;
  prCartonArrangement :number;
  prSameAsLink :number;
  prGenericQuote :number;

  prLabelingStickersText :string;
  prCustomPrintingText :string;
  prBundlingText :string;
  prVariousPrepText :string;
  prCartonArrangementText :string;
  prGenericQuoteText :string;

  odSampleToMatch :number;
  odSoldOnAmazon :number;
  odProProductPictures :number;
  odNeedHelpInPrototype :number;
  odNeedGraphicDesign :number;
  odSpecialCertificates :number;
  odInfoDetails :string;

  productTypeId :number;
  productType :string;

  internalSku :string;
  productDeptId :number;
  preferredVendorId :number;

  shippingWeight :any;
  dimensionalWeight :any;
  productWeight :any;
  cartonWeight :any;
  boxWeight :any;
  palletWeight :any;

  materials :any;
  customFields :any;
  packageCost :number;
  laborCost :number;

  rfqAttachments ?:RfqAttachment[];
  userAccount ?:any;
  admins ?:any;
  members ?:any;
  locations ?:any;
  variantSkus ?:any;
  variantParentId ?:number;
  basePrice ?:any;
  stock ?:IRfqStock;
  isDiscontinued :any;
  variantSkusCount :any;
  lotTracking :boolean;

  unitClassId :number;
  type :string;
}

export interface RfqAttachment {
  id :number;
  rfq_id :number;
  filename :string;
  filetype :string;
  fileurl :string;
  thumburl :string;
  remarks ?:string;
}

export interface IRfqStock {
  id :number;
  availableQuantity :number;
  onHandQuantity :number;
  onHoldQuantity :number;
  pendingQuantity :number;
  createdAt :Date;
  inStockQuantity :number;
  inboundQuantity :number;
  lastQuantitySync :number;
  incomingQuantity :number;
  locationId :number;
  pickedQuantity :number;
  rfq_id :number;
  sku :string;
  status :string;
  totalFbaQuantity :number;
  transferQuantity :number;
  updatedAt :Date;
  warehouseId :number;
}

export interface IRfqProductSubstitution {
  priority :number;
  substituteProduct :IRfq;
  substituteProductId :number;
  product ?:IRfq;
  productId ?:number;
  id ?:number | null;
}
